export const getSettings = (deptPreference, departments) => {
    var settings = [];
    Object.entries(deptPreference).map(([deptId, prefs]) => {
      var department = departments.find((dept) =>  {
        return dept.id == deptId
      });
      if (!department) {
        return null;
      }
      var rv = {
        userGroup: department
      }
      prefs.map((pref) => {
        rv[pref.preference] = pref.status;
      })
      settings.push(rv);
    })
     return settings;
}